import { useEffect, useState } from 'react';

import { IOption } from '../../../../../../components/Select/Select';
import { IAdminEventEnrollmentsStore } from '../../../../../../store/admin/eventEnrollments/store';
import { getPlayersOptionsFromEnrollments } from '../Utils/getPlayersOptionsFromEnrollments';

export const usePlayersOptions = (
  adminEventEnrollments: IAdminEventEnrollmentsStore,
  eventId: number
) => {
  const [playersOptions, setPlayersOptions] = useState<IOption[]>([]);

  useEffect(() => {
    if (adminEventEnrollments && adminEventEnrollments[eventId]) {
      setPlayersOptions(getPlayersOptionsFromEnrollments(adminEventEnrollments[eventId]));
    }
  }, [adminEventEnrollments[eventId]]);

  return [playersOptions];
};
